import script from "./VolunteerImpactReportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteerImpactReportPage.vue?vue&type=script&setup=true&lang=js"

import "./VolunteerImpactReportPage.vue?vue&type=style&index=0&id=e900fb26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e900fb26"]])

export default __exports__